import { currentDevice } from '../../core/utils/currentDevice'
import { hasParam } from '../../vendors/urlParser/urlParser'
import { createBottomSheet } from '../bottom_sheet/bottom_sheet'
import Modal from '../modal/modal'

if (hasParam('form_pg_sent')) {
  const DIALOG_ID = 'price-guaranteed-form-sent-success'

  if (currentDevice.isMobile) {
    const formSentSheet = createBottomSheet({ sheetId: DIALOG_ID })

    formSentSheet.show()
  } else {
    Modal.show(DIALOG_ID, {
      onShow: () => {
        ScrollLock.on()
      },
      onClose: () => {
        ScrollLock.off()
      },
      awaitCloseAnimation: true,
    })
  }
}
